import s from './GigAssRecommendTags.module.sass'
import { sendMessageRequest } from './../../model/actions'

import { FC, memo, useCallback, useMemo, useState, useEffect } from 'react'

import { useAppDispatch } from '@app/model/store'

import { Text } from '@shared/ui/Typography/Text'
import { Button } from '@shared/ui/Actions/Button'
import { EGG } from '@shared/api/analytics'

type TagData = {
  display: string
  request: string
}

type Props = {
  tags: (string | TagData)[]
  isVisible: boolean
  messagesLength: number
}

/**
 * @function RecommendTags - для отображения списка рекомендованных тегов
 */
const GigAssRecommendTagsComponent: FC<Props> = (props) => {
  const { tags, isVisible, messagesLength } = props

  const dispatch = useAppDispatch()
  const [debouncedTags, setDebouncedTags] = useState(tags)

  const handleTagClick = useCallback(
    (tag: string | TagData) => {
      const displayText = typeof tag === 'string' ? tag : tag.display
      const requestText = typeof tag === 'string' ? tag : tag.request

      EGG.gigachat.help_click({ page_active_tab: displayText })
      dispatch(sendMessageRequest(requestText))
    },
    [dispatch],
  )

  const memoizedContent = useMemo(() => {
    if (!debouncedTags.length) return null

    return (
      <div className={`${s.recommendTagsList} ${isVisible ? s.visible : ''}`} data-is-empty-list={messagesLength === 0}>
        {debouncedTags.map((tag, index) => {
          const displayText = typeof tag === 'string' ? tag : tag.display

          return (
            <Button
              key={index}
              className={s.recommendTagItem}
              mode='ghost'
              data-type={'recommend-tag'}
              sizes={'M'}
              onClick={() => handleTagClick(tag)}>
              <Text sizes={'M'} tag='span' className={s.recommendTagText} children={displayText} />
            </Button>
          )
        })}
      </div>
    )
  }, [debouncedTags, isVisible, handleTagClick])

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedTags(tags)
    }, 150)

    return () => clearTimeout(timer)
  }, [tags])

  return memoizedContent
}

const GigAssRecommendTags = memo(GigAssRecommendTagsComponent, (prevProps, nextProps) => {
  return prevProps.isVisible === nextProps.isVisible
})

export default GigAssRecommendTags
